import { UtmBuilderField } from '@/shared/ui/utm-builder-field/UtmBuilderField'
import { UtmBuilderItem } from '@/shared/ui/utm-builder-field/UtmBuilderItem'
import { ClickPopover } from '@/true-fsd/shared/ui/ClickPopover'
import { PickOptional } from '@synapex/tools/typescript'
import { CSSProperties, ReactNode } from 'react'

import classes from './UTMLinkEditDialog.module.scss'

interface CustomUtmBuilderFieldProps {
    disabled: boolean
    disabledMessage: string
    createEntityHandler: () => Promise<void>
    items: UtmBuilderItem[]
    fieldTitle: string
    selectedId: string
    inputValue: string
    isLoading: boolean
    setInputValue: (newValue: string) => void
    onSelectedIdChange?: (newValue: string) => void
}

const UTM_BUILDER_STYLE = {
    header: {
        height: 36,
    },
} satisfies Record<string, CSSProperties>

export const CustomUtmBuilderField = ({
    disabled,
    disabledMessage,
    createEntityHandler,
    items,
    fieldTitle,
    selectedId,
    inputValue,
    isLoading,
    setInputValue,
    onSelectedIdChange,
}: CustomUtmBuilderFieldProps) => {
    let content: ReactNode
    if (disabled) {
        const item = items.find(
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-conversion
            (item) => item.id.toString() === selectedId.toString()
        )
        content = (
            <UtmFieldDisabled
                color={item?.color}
                name={item?.name}
                message={disabledMessage}
            />
        )
    } else {
        content = (
            <UtmBuilderField
                // rootStyle={UTM_BUILDER_STYLE.root}
                headerStyle={UTM_BUILDER_STYLE.header}
                createEntityHandler={createEntityHandler}
                items={items}
                fieldTitle={fieldTitle}
                placeholder="Введите метку"
                selectedId={selectedId}
                inputValue={inputValue}
                isLoading={isLoading}
                setInputValue={setInputValue}
                onSelectedIdChange={onSelectedIdChange}
            />
        )
    }
    return (
        <div className="flex w-full flex-col gap-[7px]">
            <p className="text-xs text-black">{fieldTitle}</p>
            {content}
        </div>
    )
}

type UtmFieldDisabledProps = PickOptional<UtmBuilderItem, 'name' | 'color'> & {
    message: string
}
const UtmFieldDisabled = ({ color, name, message }: UtmFieldDisabledProps) => {
    return (
        <ClickPopover message={message}>
            <div className={classes.utmFieldDisabled}>
                {color && name && (
                    <>
                        <div
                            className={classes.color}
                            style={{ backgroundColor: color }}
                        />
                        <div className={classes.text}>{name}</div>
                    </>
                )}
            </div>
        </ClickPopover>
    )
}
